/**
 * Usage Reports Selectors
 * NgRx selectors for accessing usage reports state
 */
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UsageReportState } from '../models/usage-reports.models';

export const selectUsageReportsState = createFeatureSelector<UsageReportState>('usageReports');

export const selectStats = createSelector(
  selectUsageReportsState,
  (state) => state.stats
);

export const selectDailyUsage = createSelector(
  selectUsageReportsState,
  (state) => state.dailyUsage
);

export const selectProcessingLogs = createSelector(
  selectUsageReportsState,
  (state) => state.processingLogs
);

export const selectFilters = createSelector(
  selectUsageReportsState,
  (state) => state.filters
);

export const selectTotalLogs = createSelector(
  selectUsageReportsState,
  (state) => state.totalLogs
);

export const selectCurrentPage = createSelector(
  selectUsageReportsState,
  (state) => state.currentPage
);

export const selectPageSize = createSelector(
  selectUsageReportsState,
  (state) => state.pageSize
);

export const selectLoading = createSelector(
  selectUsageReportsState,
  (state) => state.loading
);

export const selectExporting = createSelector(
  selectUsageReportsState,
  (state) => state.exporting
);

export const selectError = createSelector(
  selectUsageReportsState,
  (state) => state.error
);

export const selectTotalPages = createSelector(
  selectTotalLogs,
  selectPageSize,
  (total, pageSize) => Math.ceil(total / pageSize)
);

export const selectMaxDailyUsage = createSelector(
  selectDailyUsage,
  (dailyUsage) => {
    if (!dailyUsage || dailyUsage.length === 0) return 1;
    return Math.max(...dailyUsage.map(d => d.count), 1);
  }
);

